
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M11.75 7.03c.47-.06.88.04 1.25.25h.01l.02.01c.23.11.44.26.61.45l1.29 1.43c.8.88 1.98 1.55 3.23 1.76.48.08.84.48.84.97 0 .63-.58 1.1-1.2.97-1.4-.28-2.8-.99-3.8-1.82v3.45h3c1.1 0 2 .9 2 2V21c0 .55-.45 1-1 1s-1-.45-1-1v-4h-5c-1.1 0-2-.9-2-2V9.1c0-1.03.73-1.95 1.75-2.07zM9 12.1v2.07c-1.16.42-2 1.52-2 2.83 0 1.66 1.34 3 3 3 1.31 0 2.42-.84 2.83-2h2.07A5 5 0 119 12.1zM12 2a2 2 0 110 4 2 2 0 010-4z","fill":"#23262D","fill-rule":"nonzero"}})])])
          )
        }
      }
    